import { useState } from "react";
import axios from "axios";

export default function JoinEmployee() {
  const [aadhaar, setAadhaar] = useState("");
  const [employee, setEmployee] = useState(null);
  const [otp, setOtp] = useState("");
  const [step, setStep] = useState(1);

  const verifyAadhaar = async () => {
    const res = await axios.post("/api/employee/verify-aadhaar", {
      aadhaarLast4: aadhaar
    });

    setEmployee(res.data.employee);
    setStep(2);
  };

  const sendOtp = async () => {
    await axios.post("/api/employee/send-otp", {
      employeeId: employee.id
    });
    setStep(3);
  };

  const verifyOtp = async () => {
    await axios.post("/api/employee/verify-otp", {
      employeeId: employee.id,
      otp
    });

    alert("Successfully Joined 🎉");
    setStep(4);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded-xl shadow-md w-96">

        <h2 className="text-xl font-semibold mb-6 text-center">
          Employee Join Verification
        </h2>

        {step === 1 && (
          <>
            <input
              type="text"
              maxLength="4"
              placeholder="Enter Last 4 Aadhaar"
              className="w-full p-2 border rounded mb-4"
              value={aadhaar}
              onChange={(e) => setAadhaar(e.target.value)}
            />
            <button
              onClick={verifyAadhaar}
              className="w-full bg-blue-600 text-white py-2 rounded"
            >
              Verify Details
            </button>
          </>
        )}

        {step >= 2 && employee && (
          <div className="mb-4 p-3 bg-gray-50 rounded">
            <p><b>Name:</b> {employee.fullName}</p>
            <p><b>Phone:</b> {employee.phone}</p>
            <p><b>Email:</b> {employee.email}</p>
          </div>
        )}

        {step === 2 && (
          <button
            onClick={sendOtp}
            className="w-full bg-green-600 text-white py-2 rounded"
          >
            Send OTP
          </button>
        )}

        {step === 3 && (
          <>
            <input
              type="text"
              placeholder="Enter OTP"
              className="w-full p-2 border rounded mb-4"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />
            <button
              onClick={verifyOtp}
              className="w-full bg-purple-600 text-white py-2 rounded"
            >
              Verify & Join
            </button>
          </>
        )}

        {step === 4 && (
          <div className="text-center text-green-600 font-semibold">
            Successfully Joined 🎉
          </div>
        )}

      </div>
    </div>
  );
}